<div class="modal-header">
    <h3 class="modal-title" id="modal-title" [translate]="'NOTIFICATION_DETAIL_EQUIPMENTS_OTHER_TASKS_TITLE'"></h3>
    <span class="close" (click)="modalInstance.hide()">&times;</span>
</div>
<div class="modal-body">
    @if (assignedTask) {
        <div
            class="text-success p-2 mb-1"
            [translate]="'NOTIFICATION_DETAIL_EQUIPMENTS_OTHER_TASKS_SUCCESS_MESSAGE'"
        ></div>
        <pace-notification-preview
            [notification]="convertToPreview(assignedTask)"
            [notificationType]="getTypeLabel(assignedTask)"
            [extraLinks]="[successBackLink]"
        ></pace-notification-preview>
    } @else {
        <tabset type="pills" paceCoreTabsRole>
            <tab [heading]="description">
                <pace-other-task-list
                    [tasks]="(equipmentNotifications$ | async) ?? []"
                    [state]="{
                        isLoading: (equipmentLoading$ | async) ?? false,
                        hasError: (equipmentError$ | async) ?? false,
                    }"
                    (getTask)="getTask($event, true)"
                ></pace-other-task-list>
            </tab>
            <tab
                [heading]="'NOTIFICATION_DETAIL_EQUIPMENTS_OTHER_TASKS_CUSTOMER_HEADING' | translate"
                [disabled]="!hasCustomerId"
            >
                <pace-other-task-list
                    [isCustomerTab]="true"
                    [tasks]="(customerNotifications$ | async) ?? []"
                    [state]="{
                        isLoading: (customerLoading$ | async) ?? false,
                        hasError: (customerError$ | async) ?? false,
                    }"
                    (getTask)="getTask($event, false)"
                ></pace-other-task-list>
            </tab>
        </tabset>
    }
</div>
